import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";


// Get Table Data
export const WaterSupplyPipelineTableDataAPI = createAsyncThunk("WaterSupplyPipelineTableData", async ({ data }) => {
    const {
        M_WS_PipeLineID,
        M_WS_JunctionID,
        M_WardID,
        PipelineDetails,
        M_UserID,
        FromTop,
        ToTop,
        token,
        DashProjectTypeId,
        RoleID,
        handleWaterSupplyPipelineExport
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    let url
    if (DashProjectTypeId == 6 && RoleID != '16') {
        url = `${BaseUrl}/Master/Get_WEB_M_Distri_WS_PipeLine_Select?M_Distri_WS_PipeLineID=${M_WS_PipeLineID ? M_WS_PipeLineID : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&M_Distri_WS_LocationID=${M_WS_JunctionID ? M_WS_JunctionID : '0'}&PipelineDetails=${PipelineDetails}&M_UserID=${M_UserID}&From=${FromTop}&To=${ToTop}`
    } else {
        url = `${BaseUrl}/Master/Get_WEB_M_WS_PipeLine_Select?M_WS_PipeLineID=${M_WS_PipeLineID ? M_WS_PipeLineID : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WS_JunctionID=${M_WS_JunctionID ? M_WS_JunctionID : '0'}&PipelineDetails=${PipelineDetails}&M_UserID=${M_UserID}&FromTop=${FromTop}&ToTop=${ToTop}`
    }
    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleWaterSupplyPipelineExport && handleWaterSupplyPipelineExport()
                return result.data
            } else {
                return result
            }
        })
})

const WaterSupplyPipelineTableDataSlice = createSlice({
    name: "WaterSupplyPipelineTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterSupplyPipelineTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WaterSupplyPipelineTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WaterSupplyPipelineTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WaterSupplyPipelineTableDataReducer = WaterSupplyPipelineTableDataSlice.reducer


export const WaterSupplyPipelineExportTableDataAPI = createAsyncThunk("WaterSupplyPipelineExportTableData", async ({ data }) => {
    const {
        M_WS_PipeLineID,
        M_WS_JunctionID,
        M_WardID,
        PipelineDetails,
        M_UserID,
        FromTop,
        ToTop,
        token,
        DashProjectTypeId,
        RoleID
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    // let url
    // if (DashProjectTypeId == 6 && RoleID != '16') {
    //     url = ``
    // } else {
    //     url = `${BaseUrl}/Master/Get_WEB_M_WS_PipeLine_Select?M_WS_PipeLineID=${M_WS_PipeLineID}&M_WS_JunctionID=${M_WS_JunctionID}&PipelineDetails=${PipelineDetails}&M_UserID=${M_UserID}&FromTop=${FromTop}&ToTop=${ToTop}`
    // }
    let url
    if (DashProjectTypeId == 6 && RoleID != '16') {
        url = `${BaseUrl}/Master/Get_WEB_M_Distri_WS_PipeLine_Select?M_Distri_WS_PipeLineID=${M_WS_PipeLineID ? M_WS_PipeLineID : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&M_Distri_WS_LocationID=${M_WS_JunctionID ? M_WS_JunctionID : '0'}&PipelineDetails=${PipelineDetails}&M_UserID=${M_UserID}&From=${FromTop}&To=${ToTop}`
    } else {
        url = `${BaseUrl}/Master/Get_WEB_M_WS_PipeLine_Select?M_WS_PipeLineID=${M_WS_PipeLineID ? M_WS_PipeLineID : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WS_JunctionID=${M_WS_JunctionID ? M_WS_JunctionID : '0'}&PipelineDetails=${PipelineDetails}&M_UserID=${M_UserID}&FromTop=${FromTop}&ToTop=${ToTop}`
    }
    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WaterSupplyPipelineExportTableDataSlice = createSlice({
    name: "WaterSupplyPipelineExportTableData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterSupplyPipelineExportTableDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(WaterSupplyPipelineExportTableDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(WaterSupplyPipelineExportTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WaterSupplyPipelineExportTableDataReducer = WaterSupplyPipelineExportTableDataSlice.reducer


// InsertUpdate Table Data

export const WaterSupplyPipelinePostDataAPI = createAsyncThunk("WaterSupplyPipelinePostData", async ({ data }) => {
    const {
        M_WS_PipeLineID,
        M_WS_JunctionID,
        PipelineDetails,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        handleClearField,
        handleOnCloseClick,
        DashProjectTypeId,
        M_Distri_WS_PipeLineID,
        RoleID

    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();

    if (DashProjectTypeId == '6' && RoleID != '16') {
        formdata.append("M_Distri_WS_PipeLineID", M_Distri_WS_PipeLineID);
        formdata.append("M_Distri_WS_LocationID", M_WS_JunctionID);
    } else {
        formdata.append("M_WS_PipeLineID", M_WS_PipeLineID);
        formdata.append("M_WS_JunctionID", M_WS_JunctionID);
    }

    formdata.append("PipelineDetails", PipelineDetails);
    formdata.append("M_UserID", M_UserID);
    formdata.append("Flag", Flag);

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    let url
    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/Master/Post_WEB_M_Distri_WS_PipeLine_InsertUpdate`
    } else {
        url = `${BaseUrl}/Master/Post_WEB_M_WS_PipeLine_InsertUpdate`
    }
    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                handleOnCloseClick()
                toastErrorr(result.message)
            }

            return result
        })
})

const WaterSupplyPipelinePostDataSlice = createSlice({
    name: "WaterSupplyPipelinePostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterSupplyPipelinePostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WaterSupplyPipelinePostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WaterSupplyPipelinePostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WaterSupplyPipelinePostDataReducer = WaterSupplyPipelinePostDataSlice.reducer



// // // Delete Table Data

export const WaterSupplyPipelineMasterDeleteAPI = createAsyncThunk("WaterSupplyPipelineMasterDelete", async ({ data }) => {

    const {
        M_WS_PipeLineID,
        M_Distri_WS_PipeLineID,
        M_UserID,
        handleIsPost,
        token,
        DashProjectTypeId,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();

    if (DashProjectTypeId == '6' && RoleID != '16') {
        formdata.append("M_Distri_WS_PipeLineID", M_Distri_WS_PipeLineID);
    } else {
        formdata.append("M_WS_PipeLineID", M_WS_PipeLineID);
    }

    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    let url
    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/Master/WEB_M_Distri_WS_PipeLine_Delete`
    } else {
        url = `${BaseUrl}/Master/WEB_M_WS_PipeLine_Delete`
    }
    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                // handleDeleteCloseClick()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)
                // handleDeleteCloseClick()
            }
            return result

        })
})

const WaterSupplyPipelineMasterDeleteSlice = createSlice({
    name: "WaterSupplyPipelineMasterDelete",
    initialState: {
        isDeleteLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterSupplyPipelineMasterDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(WaterSupplyPipelineMasterDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.tableData = action.payload;
            // toastSuccesss(action.payload.message)
        });
        builder.addCase(WaterSupplyPipelineMasterDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WaterSupplyPipelineMasterDeleteReducer = WaterSupplyPipelineMasterDeleteSlice.reducer